<p class="close">
	<span (click)="close.emit()">&times;</span>
</p>
<p>{{current_image + 1}} / {{imgs.length}}</p>
<p class="main-image">
	<img [src]="imgs[current_image]" alt="">
</p>
<p class="thumbs">
	<img [src]="img" *ngFor="let img of imgs; let i = index" alt="" (click)="current_image = i" [ngClass]="{active: i == current_image}">
</p>